import { KsService } from '@siclop/kstone-vue'

export class ActivityService extends KsService {
  protected static mainUrl = '/activities'
}
